module.exports = __webpack_public_path__ + "static/media/googleIcon.fd19b481.svg";